module.exports = __webpack_public_path__ + "img/logo.d1ae8406.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intrising-logo/logo.svg
// module id = tBWE
// module chunks = 1